import { useTranslation } from 'react-i18next';
import { Text, tokens, Stack } from '@hotjar/hotsauce';
import { CMS } from '@hotjar/webapp/features/Activation/SetupWizard/steps/IntegrationGuides';
import type { Site } from '@hotjar/site';
import { GTMInstallationHero } from './GTMInstallationHero';
import { CMSInstallationHero } from './CMSInstallationHero';

interface DetectedPlatformProps {
  detectedCMS?: CMS;
  withGTM?: boolean;
  url: Site['url'];
  onCMSClick: (cms: CMS) => void;
  onOtherPlatformsClick: () => void;
}

export const DetectedPlatform = ({
  detectedCMS,
  withGTM,
  url,
  onCMSClick,
  onOtherPlatformsClick,
}: DetectedPlatformProps): JSX.Element | null => {
  const { t } = useTranslation();
  const withSupportedCMS = detectedCMS && Object.values(CMS).includes(detectedCMS);
  const platformDetected = withSupportedCMS || withGTM;

  return platformDetected ? (
    <Stack
      direction="column"
      spacing="x1pt5"
      css={{ marginBottom: tokens.spacer.x4 }}
      data-testid="detected-platform-section"
    >
      <Text textType="header5" as="h4">
        {t('activation:setup-wizard.specific-integration.title', {
          url,
        })}
      </Text>
      {withGTM ? (
        <GTMInstallationHero onOtherPlatformsClick={onOtherPlatformsClick} />
      ) : (
        <>
          {detectedCMS ? (
            <CMSInstallationHero
              onCMSClick={onCMSClick}
              onOtherPlatformsClick={onOtherPlatformsClick}
              cms={detectedCMS}
            />
          ) : null}
        </>
      )}
    </Stack>
  ) : null;
};
